import React, { useEffect, useMemo } from "react"
import Tab1 from "./tabs/Tab1";
import Tab2 from "./tabs/Tab2";
import Tab3 from "./tabs/Tab3";
import "../../../UserManagement/user-form-wizard/form-wizard.css"
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormNav from "./FormNavBar";

const ThemeFormWizard = ({ tab, setTab, data = {}, isLoading, submitData, includeImageFields = true }) => {
    const { assets = [], ...themeData } = data
    const colorHexRegex = /^0x([0-9a-fA-F]{6})$/;

    /* Auto scroll to top on new tab */
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, [tab])

    const validationSchemaObject = {
        name: Yup.string().required('Required'),
        description: Yup.string().required('Required'),
        status: Yup.string().required('Required'),
        userGroup: Yup.string().required('Required'),
        assets: Yup.object()
    }

    if (includeImageFields) {
        validationSchemaObject.logo = Yup.string().required('Required')
        validationSchemaObject.logoBackgroundColor = Yup.string().matches(colorHexRegex, "Invalid hex color").required('Required')
        validationSchemaObject.banner = Yup.string().required('Required')
        validationSchemaObject.bannerBackgroundColor = Yup.string().matches(colorHexRegex, "Invalid hex color").required('Required')
        validationSchemaObject.webSpotlightImage = Yup.string().required('Required')
        validationSchemaObject.mobileSpotlightImage = Yup.string().required('Required')
    }

    const assetsMap = useMemo(() => {
        const map = {}
        for (const asset of assets) {
            map[asset.instrumentId || asset.id] = asset
        }
        return map
    }, [assets])

    const validationSchema = Yup.object(validationSchemaObject)

    return (
        <Formik
            initialValues={{
                name: "",
                description: "",
                banner: "",
                bannerBackgroundColor: "",
                logo: "",
                logoBackgroundColor: "",
                webSpotlightImage: "",
                mobileSpotlightImage: "",
                status: "active",
                userGroup: "",
                assets: assetsMap,
                ...themeData,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => {
                await submitData(values)
            }}
        >{({ status, validateForm, values, setFieldValue }) => (
            <Form>
                <div className="text-warning">{status}</div>
                <div className="container">
                    <div className="card card-custom card-transparent" id="user-wizard">
                        <div className="card-body p-0">
                            {/* <!--begin: Wizard--> */}
                            <div className="wizard wizard-4" id="kt_wizard" data-wizard-state="step-first"
                                data-wizard-clickable="true">
                                <FormNav tab={tab} setTab={setTab} />
                                {/* <!--begin: Wizard Body--> */}
                                <div className="card card-custom card-shadowless rounded-top-0">
                                    <div className="card-body p-0">
                                        <div className="row justify-content-center py-8 px-8 py-lg-15 px-lg-10">
                                            <div className="col-xl-12 col-xxl-8">
                                                <Tab1
                                                    tab={tab}
                                                    onValidate={() => {
                                                        validateForm().then((errors) => {
                                                            if (
                                                                errors.name
                                                                || errors.description
                                                                || errors.banner
                                                                || errors.logo
                                                                || errors.webSpotlightImage
                                                                || errors.mobileSpotlightImage
                                                                || errors.userGroup
                                                            ) return;
                                                            setTab(2)
                                                        })
                                                    }}
                                                    setFieldValue={setFieldValue}
                                                    includeImageFields={includeImageFields}
                                                />
                                                <Tab2
                                                    tab={tab}
                                                    onValidate={() => {
                                                        validateForm().then((errors) => {
                                                            if (errors.assets) return;
                                                            setTab(3)
                                                        })
                                                    }}
                                                    setTab={setTab}
                                                    selectedInstruments={values.assets}
                                                    setFieldValue={setFieldValue}
                                                />
                                                <Tab3
                                                    tab={tab}
                                                    setTab={setTab}
                                                    isSubmitting={isLoading}
                                                    themeData={values}
                                                    includeImageFields={includeImageFields}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--end: Wizard Bpdy--> */}
                            </div>
                            {/* <!--end: Wizard--> */}
                        </div>
                    </div>
                </div>
            </Form>
        )}</Formik>
    )

}

export default ThemeFormWizard;
